import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading, Image, Link, Text } from '@chakra-ui/react';
import { Card } from '@whitbread-eos/atoms';
import { formatAssetsUrl, formatDataTestId, useScreenSize } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MAX_CARDS_NUMBER = 4;
var MIN_CARDS_NUMBER = 2;
export default function DestinationCarousel(_ref) {
  var title = _ref.title,
    items = _ref.items,
    baseDataTestId = _ref.baseDataTestId;
  var _useScreenSize = useScreenSize(),
    isLessThanXl = _useScreenSize.isLessThanXl;
  var isFadeEffect = items.length > MAX_CARDS_NUMBER || isLessThanXl;
  if (items.length < MIN_CARDS_NUMBER) return;
  return _jsxs(Box, {
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper'),
    children: [_jsx(Heading, _objectSpread(_objectSpread({
      as: "h2"
    }, headingStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title'),
      children: title
    })), _jsx(Flex, _objectSpread(_objectSpread({}, _objectSpread({}, destinationCarouselContainerStyles)), {}, {
      sx: _objectSpread({}, isFadeEffect && {
        '&::after': _objectSpread({}, fadeEffectOverlayStyles)
      }),
      "data-testid": formatDataTestId(baseDataTestId, 'List'),
      children: items.map(item => _jsx(DestinationCard, {
        destination: item,
        "data-testid": formatDataTestId(baseDataTestId, 'Card'),
        cardLength: items.length
      }, item.title))
    }))]
  });
}
function DestinationCard(_ref2) {
  var destination = _ref2.destination,
    cardLength = _ref2.cardLength;
  var _getCardStyle = getCardStyle(cardLength),
    wrapperStyles = _getCardStyle.wrapperStyles,
    cardContainerStyles = _getCardStyle.cardContainerStyles,
    imageStyle = _getCardStyle.imageStyle;
  return _jsx(Box, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
    children: _jsx(Link, _objectSpread(_objectSpread({
      href: destination.link
    }, linkStyles), {}, {
      children: _jsxs(Card, _objectSpread(_objectSpread({}, cardContainerStyles), {}, {
        children: [_jsx(Image, _objectSpread({
          alt: destination.title,
          src: formatAssetsUrl(destination.picture)
        }, imageStyle)), _jsx(Text, _objectSpread(_objectSpread({}, cardTitleStyles), {}, {
          children: destination.title
        }))]
      }))
    }))
  }));
}
function getCardStyle(cardLength) {
  var baseStyles = {
    wrapperStyles: {
      w: {
        mobile: '19.313rem',
        sm: '18.375rem',
        xl: '19.313rem'
      }
    },
    cardContainerStyles: {
      bgColor: 'baseWhite',
      display: 'flex',
      direction: 'column',
      minH: '11.125rem',
      border: '1px solid var(--chakra-colors-lightGrey4)',
      borderRadius: 'var(--chakra-space-radiusSmall)',
      boxShadow: 'none',
      padding: '0',
      w: {
        mobile: '19.313rem',
        sm: '18.375rem',
        xl: '19.313rem'
      },
      _hover: {
        cursor: 'pointer',
        boxShadow: '0 0 var(--chakra-space-sm) 0 var(--chakra-colors-lightGrey2)',
        transitionProperty: 'border, box-shadow',
        transitionDuration: '0s, 0s',
        transitionTimingFunction: 'ease, ease',
        transitionDelay: '0s, 0s'
      }
    },
    imageStyle: {
      borderTopRadius: 'var(--chakra-space-radiusSmall)',
      width: '309px',
      height: '178px'
    }
  };
  switch (cardLength) {
    case 2:
      return {
        wrapperStyles: _objectSpread(_objectSpread({}, baseStyles.wrapperStyles), {}, {
          w: {
            mobile: '19.313rem',
            sm: '40.125rem'
          }
        }),
        cardContainerStyles: _objectSpread(_objectSpread({}, baseStyles.cardContainerStyles), {}, {
          minH: {
            mobile: '11.125rem',
            sm: '21.563rem'
          },
          w: {
            mobile: '19.313rem',
            sm: '40.125rem'
          }
        }),
        imageStyle: _objectSpread(_objectSpread({}, baseStyles.imageStyle), {}, {
          width: '642px',
          height: {
            mobile: '178px',
            sm: '345px'
          }
        })
      };
    case 3:
      return {
        wrapperStyles: _objectSpread(_objectSpread({}, baseStyles.wrapperStyles), {}, {
          w: {
            mobile: '19.313rem',
            sm: '26.25rem'
          }
        }),
        cardContainerStyles: _objectSpread(_objectSpread({}, baseStyles.cardContainerStyles), {}, {
          minH: {
            mobile: '11.125rem',
            sm: '18.25rem'
          },
          w: {
            mobile: '19.313rem',
            sm: '26.25rem'
          }
        }),
        imageStyle: _objectSpread(_objectSpread({}, baseStyles.imageStyle), {}, {
          width: '420px',
          height: {
            mobile: '178px',
            sm: '242px'
          }
        })
      };
    case 4:
    default:
      return _objectSpread({}, baseStyles);
  }
}
var headingStyle = {
  fontSize: '1.8rem',
  fontWeight: '900',
  lineHeight: '2rem',
  color: 'tertiary',
  marginBottom: 'var(--chakra-space-lg)'
};
var linkStyles = {
  cursor: 'default',
  _hover: {
    textDecoration: 'none'
  },
  _focus: {
    textDecoration: 'none',
    boxShadow: 'none'
  },
  _visited: {
    textDecoration: 'none'
  },
  _link: {
    textDecoration: 'none'
  },
  _active: {
    textDecoration: 'none'
  }
};
var destinationCarouselContainerStyles = {
  overflowY: 'auto',
  pb: '2xl',
  gap: 'lg',
  flexWrap: 'nowrap',
  position: 'relative',
  top: 0,
  left: 0
};
var fadeEffectOverlayStyles = {
  content: '"content"',
  color: 'transparent',
  bottom: '0',
  right: '0',
  position: 'sticky',
  width: '50px',
  background: 'linear-gradient(-90deg, #FFFFFF 0%, rgba(255, 255, 255, 0))'
};
var cardTitleStyles = {
  p: 'md',
  fontWeight: 700,
  fontSize: 'md'
};